import React from 'react';
import Dsy from './dsyui';
import { createComponent } from '@lit-labs/react';

const LitComp = Dsy.components.DsyHeader;

export const DsyHeader = createComponent(
  React,
  'dsy-header',
  LitComp,
  {},
);
